(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeePreAuthorizationsController', Controller);

    Controller.$inject = ['$scope', '$translate', 'authorizedBusinessTasks', 'authorizedSystemRoles', 'defaultEntitlementSysRoles', 'employee'];

    function Controller($scope, $translate, authorizedBusinessTasks, authorizedSystemRoles, defaultEntitlementSysRoles, employee) {

        $scope.isRestrictedZone = (authorizedBusinessTasks.IsRestrictedZone === true) ||
                                  (authorizedSystemRoles.IsRestrictedZone === true) ||
                                  (defaultEntitlementSysRoles.IsRestrictedZone === true);

        $scope.authorizedSysRolesBySystem                = getAuthorizedSysRolesBySystem();
        $scope.authorizedBusinessTasksByProcess          = getBusinessTasksByProcess(authorizedBusinessTasks);
        $scope.defaultEntitlementsBySystemNoNetworkShare = getDefaultEntitlementSysRolesBySystem();
        $scope.defaultEntitlementsNetworkShare           = getNetworkShareSystemType();
        $scope.employee                                  = employee;

        $translate('iam.employee.preAuthorizations.pageTitle').then(function(translation) {
            $scope.updateTopBar(translation, 'fa fa-gavel');
        });

        function getAuthorizedSysRolesBySystem() {
            return _.chain(authorizedSystemRoles)
                    .groupBy('SystemID')
                    .map(function (sysRoles, systemID) {
                        return _.assign({ SystemRoles: sysRoles }, _.pick(sysRoles[0], ['SystemID', 'SystemName', 'SystemCssIconClasses']));
                    })
                    .value();
        }

        function getDefaultEntitlementSysRolesBySystem() {
            return _.chain(defaultEntitlementSysRoles)
                .reject({ SystemTypeID: 4 }) // Reject Network Share type
                .groupBy('SystemID')
                .map(function (sysRoles, systemID) {
                    return _.assign({ SystemRoles: sysRoles }, _.pick(sysRoles[0], ['SystemID', 'SystemName', 'SystemCssIconClasses']));
                })
                .value();
        }

        function getNetworkShareSystemType() {
            return _.chain(defaultEntitlementSysRoles)
                .filter({ SystemTypeID: 4 }) // Keep Only Network Share type
                .groupBy('SystemTypeID')
                .map(function (systemRolesByType, systemTypeID) {
                    return _.assign({ SystemRoles: systemRolesByType }, _.pick(systemRolesByType[0], ['SystemTypeName', 'SystemCssIconClasses']));
                })
                .first()
                .value();
        }


        function getBusinessTasksByProcess(businessTasks) {
            return _.chain(businessTasks)
                .groupBy('BusinessProcessId')
                .map(function (activities, businessProcessID) {
                    return _.assign({ Activities: groupTasksByActivity() }, _.pick(activities[0], ['BusinessProcessName']));

                    function groupTasksByActivity() {
                        return _.chain(activities)
                            .groupBy('BusinessActivityId')
                            .map(function (tasks, businessActivityId) {
                                return _.assign({ Tasks: tasks }, _.pick(tasks[0], ['BusinessActivityName']));
                            })
                            .value();
                    }
                })
                .value();
        }
    }
})();